import type { TranslationsListRow } from "@/admin/entities/translations";
import type { TranslationsListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: TranslationsListRow[];
  count: number;
} {
  const list = (data as TranslationsListQueryType)?.translations;

  if (!list?.nodes) {
    return { nodes: [], count: 0 };
  }

  return list;
}

export function mapColumns(row: TranslationsListRow) {
  return [row.id, row, row.version, row, row, row.updatedAt];
}
